import type { TranslationDownload } from "./message-file"

export function translationMarkdown(text: string, files: readonly TranslationDownload[]) {
  if (!files.length) return text
  return text.replace(
    /(^|\n)[ \t]*(`{3,}|~{3,})[^\n]*\n[\s\S]*?(?:\n[ \t]*\2[^\n]*(?=\n|$)|$)|(`+)[^\n]*?\3|(?<!!)(\[[^\]\n]*\]\()translation-result:\/\/files\/([a-f0-9]{32})(\))/g,
    (match, _start, _fence, _code, prefix, id, suffix) =>
      prefix && files.some((file) => file.uri === `translation-result://files/${id}`)
        ? `${prefix}#translation-result-${id}${suffix}`
        : match,
  )
}

export function markTranslationDownloads(root: HTMLElement, files: readonly TranslationDownload[], title: string) {
  root.querySelectorAll<HTMLAnchorElement>("a[data-translation-download]").forEach((link) => {
    const file = files.find((file) => file.uri === link.dataset.translationDownload)
    if (file) {
      link.href = file.url
      link.download = file.filename
      return
    }
    const code = document.createElement("code")
    code.textContent = link.dataset.translationDownload ?? ""
    link.replaceWith(code)
  })
  const link = (node: Element, file: TranslationDownload, label: string) => {
    const anchor = document.createElement("a")
    anchor.href = file.url
    anchor.download = file.filename
    anchor.title = title
    anchor.dataset.translationDownload = file.uri
    anchor.textContent = label
    anchor.setAttribute("aria-label", label)
    node.replaceWith(anchor)
  }
  root.querySelectorAll("a[href^='#translation-result-']").forEach((node) => {
    if (node.closest("pre")) return
    const uri = `translation-result://files/${node.getAttribute("href")?.slice("#translation-result-".length)}`
    const file = files.find((file) => file.uri === uri)
    if (file) link(node, file, node.textContent || file.filename)
  })
  root.querySelectorAll(":not(pre) > code").forEach((code) => {
    if (code.closest("pre, a[data-translation-download]")) return
    const text = code.textContent?.trim()
    const candidates = files.filter((file) => file.uri === text)
    if (candidates.length !== 1) return
    const file = candidates[0]!
    link(code.parentElement?.tagName === "A" ? code.parentElement : code, file, file.filename)
  })
}
